<template>
  <v-dialog
    v-model="dialogAtivo"
    content-class="bar-12"
    width="1400px"
    persistent
    transition="dialog-top-transition"
  >
    <v-card class="px-2">
      <div class="d-flex pl-12 pr-5 pt-3 pb-2">
        <div>
          <p v-text="'Cotação'" class="ma-0 font-24" />
          <p
            id="subtitulo-dialog"
            v-text="'Selecione quais fornecedores e produtos você deseja realizar cotação'"
          />
        </div>

        <v-spacer />

        <div class="d-flex align-center">
          <RelatoriosAutocomplete
            v-model="relatorioSelecionado"
            hide-details
            outlined
            dense
            class="mb-2"
            exibir_todos_relatorios
            append-icon="mdi-chevron-down"
          />
        </div>
      </div>

      <v-divider />

      <div class="w-full d-flex px-4" v-if="dialogAtivo">
        <v-col cols="7" class="pa-0 border-r">
          <FornecedoresPorCotar
            v-model="marcasSelecionadas"
            :pedido="pedido"
            :dialog_ativo="dialogAtivo"
            class="mt-5 mr-1"
          />
        </v-col>
        <v-col cols="5">
          <MarcasASeremCotadas v-model="marcasSelecionadas" class="pa-0 mx-1" />
        </v-col>
      </div>

      <v-divider />

      <div class="d-flex pt-5 pb-6 pr-5">
        <v-spacer />

        <SysBotao class="mr-3" background="white" @click="dialogAtivo = false">
          Cancelar
        </SysBotao>

        <form
          :action="relatorioSelecionado.url"
          method="post"
          target="_blank"
        >
          <input type="text" hidden name="id_pedido" :value="pedido.id" />
          <input type="text" hidden name="marcas" :value="JSON.stringify(marcasSelecionadas)" />

          <SysBotao
            v-if="marcasSelecionadas.length > 0"
            type="submit"
            background="#142454"
            color-texto="white"
            class="font-16"
            radius="8"
            v-text="`Gerar ${marcasSelecionadas.length} Cotações`"
          />

          <SysBotao
            v-else
            background="rgba(0, 0, 0, 0.16)"
            color-texto="rgba(0, 0, 0, 0.16)"
            class="font-16"
            radius="8"
            disabled
            v-text="'Gerar Cotações'"
          />
        </form>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import SysBotao from "../../../../utils/botoes/SysBotao";
import RelatoriosAutocomplete from "./RelatoriosAutocomplete";
import FornecedoresPorCotar from "./fornecedores/Index";
import MarcasASeremCotadas from "./MarcasASeremCotadas";

export default {
  name: "GerarCotacaoDialog",
  components: {
    MarcasASeremCotadas,
    FornecedoresPorCotar,
    RelatoriosAutocomplete,
    SysBotao
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: Boolean,
    pedido: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    relatorioSelecionado: {},
    marcasSelecionadas: []
  }),
  computed: {
    dialogAtivo: {
      get: function () {
        return this.modelValue;
      },
      set: function (value) {
        this.$emit("update:modelValue", value);
      }
    }
  }
}
</script>

<style scoped>
#subtitulo-dialog {
  font-size: 12px;
  font-weight: 500;
}
.border-r {
  border-right: 1px solid #e0e0e0;
}
</style>
